import SectionInfographic from "@/components/SectionInfographic";
import { Sparkles, Workflow, BarChart3, Lock } from "lucide-react";

const SECTIONS = [
  { key: "overview",     label: "Overview",           Icon: Sparkles,   blurb: "What this module is at a glance." },
  { key: "how-it-works", label: "How it works",       Icon: Workflow,   blurb: "The 4-step workflow, end to end." },
  { key: "outcomes",     label: "Outcomes",           Icon: BarChart3,  blurb: "The measurable business impact." },
  { key: "guardrails",   label: "Guardrails",         Icon: Lock,       blurb: "Safety, consent, and human review." },
];

/* Renders 4 AI-generated section infographics in a 2x2 grid.
 * Used on feature pages that want to expose the full section-level
 * visual story on a single scroll — grounded in the same backend
 * FEATURE_CATALOG.
 *
 * Props:
 *   slug   — feature slug
 *   accent — hex accent for shadow tint
 */
export default function SectionInfographicGrid({ slug, accent = "#4F46E5" }) {
  return (
    <section
      className="mt-12"
      data-testid={`section-infographic-grid-${slug}`}
    >
      <div className="flex items-baseline justify-between flex-wrap gap-3">
        <div>
          <div className="text-xs uppercase tracking-widest font-bold text-slate-500">
            The 4-panel picture
          </div>
          <h3 className="mt-1 text-2xl font-bold text-slate-900">
            Every angle of this module, illustrated by AI
          </h3>
        </div>
        <div className="text-xs text-slate-500 max-w-xs">
          Rendered live from this module's real capability list — regenerates on demand.
        </div>
      </div>

      <div className="mt-6 grid grid-cols-1 md:grid-cols-2 gap-6">
        {SECTIONS.map((s) => (
          <div key={s.key} className="flex flex-col">
            <div className="mb-2 inline-flex items-center gap-2 text-xs font-bold uppercase tracking-widest text-slate-700">
              <s.Icon className="w-3.5 h-3.5" style={{ color: accent }} />
              {s.label}
            </div>
            <SectionInfographic
              slug={slug}
              section={s.key}
              theme="dark"
              accent={accent}
              caption={s.blurb}
            />
          </div>
        ))}
      </div>
    </section>
  );
}
